import { render, staticRenderFns } from "./RelatorioGrupo.vue?vue&type=template&id=407aee24&"
import script from "./RelatorioGrupo.vue?vue&type=script&lang=js&"
export * from "./RelatorioGrupo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports